import styled from "styled-components";
import tw from "twin.macro";

export const Content = styled.div`
    ${tw`container mx-auto px-4`};
`;
